import styled from 'styled-components';

export const Container = styled.div`
  font-family: PublicSans-Bold;
  font-size: 21px;
  line-height: 27px;

  text-align: center;
  letter-spacing: -0.3px;

  color: ${props => props.theme['text-color']};
`;
